
export class Alumno {
    alumnoid!: number;
    matricula!: string;
    nombre!: string;
    apellidopaterno!: string;
    apellidomaterno!: string;
    nivelid!: number;
    gradoid!: number;
    grupoid!: number;
    alumnoestatusid!: number;

    constructor(init?: Partial<Alumno>) {
        Object.assign(this, init);
    }
}
